import { css } from 'styled-components';

const LastPurchasedStyles = css`
  &.last-purchased {
    color: #595959;
    font-feature-settings: 'clig' 0, 'liga' 0;
    font-family: 'Nunito', sans-serif;
    font-size: 12px;
    font-style: italic;
    font-weight: 700;
    line-height: normal;
  }
  .last-purchased-values {
    color: #595959;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Nunito;
    font-size: 12px;
    font-style: italic;
    font-weight: 800;
    line-height: normal;
  }
`;

export default LastPurchasedStyles;
